import { getSrc } from "@components/HomePage/logos/utils";
import dropbox from "./images/dropbox.png";
import gdrive from "./images/gdrive.png";
import meganz from "./images/meganz.png";
import rutube from "./images/rutube.png";

const previews = {
	dropbox: getSrc(dropbox),
	gdrive: getSrc(gdrive),
	meganz: getSrc(meganz),
	rutube: getSrc(rutube),
};

export default previews;
